import {
  Badge,
  Box,
  IconChevron,
  Link,
  Spread,
  Stack,
  Text,
  Tiles,
} from 'braid-design-system';
import type { SalaryRangeByRole } from '../../../pages/salaries/salariesTabModel';

export const DesktopSalariesList = ({
  trackRoleClicked,
  paginatedSalaryRanges,
  salariesPagePath,
}: {
  paginatedSalaryRanges: SalaryRangeByRole[];
  salariesPagePath: string;
  trackRoleClicked: (roleTitle: string) => void;
}) => {
  return (
    <Tiles space={{ mobile: 'xxsmall', desktop: 'medium' }} columns={[2, 2]}>
      {paginatedSalaryRanges.map((item) => {
        const salaryRangeLabel =
          item.rangeByCompany?.label || item.rangeByIndustry?.label;

        return salaryRangeLabel ? (
          <Box
            key={item.roleId}
            cursor="pointer"
            boxShadow="borderNeutralLight"
            borderRadius="large"
            padding="small"
          >
            <Link
              href={`${salariesPagePath}/${item.roleId}`}
              onClick={() => trackRoleClicked(item.roleTitle)}
            >
              <Spread alignY="center" space="xsmall">
                <Stack space="xsmall">
                  <Text size="standard" weight="medium" maxLines={2}>
                    {item.roleTitle}
                  </Text>
                  <Badge tone="info">{salaryRangeLabel}</Badge>
                </Stack>
                <IconChevron direction="right" />
              </Spread>
            </Link>
          </Box>
        ) : null;
      })}
    </Tiles>
  );
};
